import { render } from "./AddCard.vue?vue&type=template&id=394b4ba0"
import script from "./AddCard.vue?vue&type=script&lang=js"
export * from "./AddCard.vue?vue&type=script&lang=js"

import "./AddCard.vue?vue&type=style&index=0&id=394b4ba0&lang=scss"
script.render = render

export default script